import React from 'react';
import { useMutation } from '@apollo/client';
import { useTranslation, Trans } from 'react-i18next';

import { useModalContext } from '../../context/Modal';
import { CANCEL_USER_REMOVAL_REQUEST } from '../../http/apollo-queries';
import { Button } from '../UI';
import AccountExportModal from './AccountExportModal';
import { Modal } from '../Modal';
import { Icon } from '../UI';

interface PropTypes {
  refetchUser: () => void;
}

const AccountRecoverModal: React.FC<PropTypes> = ({ refetchUser }) => {
  const { t } = useTranslation();
  const { setElement, closeModal } = useModalContext();

  const [cancelUserRemoval] = useMutation(CANCEL_USER_REMOVAL_REQUEST, {
    onCompleted: (data) => {
      if (data.cancelUserRemovalRequest.status === 'COMPLETED') {
        refetchUser();
      }
    },
  });

  const openAccountExportModal = () => {
    setElement(<AccountExportModal closeModal={closeModal} />);
  };

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'base'}
    >
      <>
        <div className={'text-center mb-4'}>
          <Icon svgName={'warning'} className="w-32 h-32 mb-8" fill={false} />
        </div>
        <h1 className={'text-black text-xl font-semibold mb-4 dark:text-white'}>
          <Trans i18nKey="modals.cancelUserRemoval.title">
            <p>first_line</p>
            <p>second_line</p>
          </Trans>
        </h1>
        <p className={'text-grey-50 text-sm whitespace-pre-wrap'}>
          {t('modals.cancelUserRemoval.subtitle')}
        </p>
        <Button
          variant="primary"
          buttonClass="mt-12"
          onClick={cancelUserRemoval}
        >
          {t('modals.cancelUserRemoval.agree')}
        </Button>
        <Button
          variant="primary"
          buttonClass="mt-12"
          onClick={openAccountExportModal}
        >
          {t('modals.cancelUserRemoval.requestData')}
        </Button>
      </>
    </Modal>
  );
};

export default AccountRecoverModal;
